<template>
  <template v-if="orderManagementDetailData.operID == 5">
    <orderDataTemplateHead
      :userSelectCode="userSelectCode"
      :modStatus="modStatus"
    />
  </template>
  <template v-else-if="orderManagementDetailData.operID == 6">
    <orderDataTemplateThread
      :userSelectCode="userSelectCode"
      :modStatus="modStatus"
    />
  </template>
  <template v-else-if="orderManagementDetailData.operID == 7">
    <orderDataTemplateHeat
      :userSelectCode="userSelectCode"
      :modStatus="modStatus"
    />
  </template>
</template>

<script>
import { inject } from "@vue/runtime-core";
import orderDataTemplateHead from "@/components/orderManagement/orderDataTemplate/orderDataTemplateHead";
import orderDataTemplateThread from "@/components/orderManagement/orderDataTemplate/orderDataTemplateThread";
import orderDataTemplateHeat from "@/components/orderManagement/orderDataTemplate/orderDataTemplateHeat";
export default {
  components: {
    orderDataTemplateHead,
    orderDataTemplateThread,
    orderDataTemplateHeat,
  },
  props: {
    userSelectCode: {
      type: Number,
      default: 0,
    },
    modStatus: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const orderManagementDetailData = inject("orderManagementDetailData");

    return { orderManagementDetailData };
  },
};
</script>

<style></style>
<style lang="scss">
.sourceRecord-input-disabled {
  background: transparent;
  color: #000;
  border-color: transparent;
}
</style>
